import * as React from 'react';

const ExclusiveBrands = ({ children  })=>/*#__PURE__*/ React.createElement("div", {
        className: "exclusive-brands"
    }, /*#__PURE__*/ React.createElement("ul", {
        className: "exclusive-brands__brand-list"
    }, children))
;

export { ExclusiveBrands as default };
//# sourceMappingURL=ExclusiveBrands.js.map
